import { defineStore } from 'pinia'

export const useProjectStore = defineStore('project', {
  state: () => ({
    selectedProject: null
  }),

  actions: {
    setProject(project) {
      this.selectedProject = project
    }
  }
})